module.exports = __webpack_public_path__ + "static/stats-parallax-5a15a4de5d4a73dfc8cd902c534e269d.jpg";